import * as React from 'react'
import {createPortal} from 'react-dom'
import {Util} from 'yougile-util'

export interface Props extends React.HTMLProps<HTMLDivElement> {
  top?: number
  left?: number
  right?: number
  zIndex?: number
  selector?: string
}

/**
 * @unstable TODO: This component has an issue with using ref in children. Because it renders elements only after state element (ref setElement) is ready, useEffect can't get refs after first render cycle
 * <example>
 * const contentRef = useRef(null);
 * useEffect(() => {
 *   console.log(contentRef.current); // will be null
 * }, []);
 *
 * <MoveToBody>
 *    <div ref={contentRef}>
 * </MoveToBody>
 * </example>
 */
export const MoveToBody = (props: Props) => {
  const {top, left, right, zIndex, selector, ...htmlProps} = props
  const [element, setElement] = React.useState<HTMLDivElement>()
  React.useEffect(() => {
    const container = selector
      ? document.querySelector(selector)
      : document.body

    const el = document.createElement('div')
    el.setAttribute(`data-origin`, Util.makeShortId())
    container?.appendChild(el)
    setElement(el)

    return () => {
      container?.removeChild(el)
    }
  }, [selector])
  const style: React.CSSProperties = {
    ...props.style,
    left: left ?? props.style?.left,
    right: right ?? props.style?.right,
    top: top ?? props.style?.top,
    zIndex: zIndex ?? props.style?.zIndex,
    position: 'absolute'
  }

  if (!element) {
    return null
  }

  return createPortal(
    <div {...htmlProps} style={style}>
      {props.children}
    </div>,
    element
  )
}
